export const phoneFormatter = number => {
  const regex = /\d+/g
  const match = number.match(regex)

  if (match) {
    return match.join('').substr(1)
  }
}
